import React, { Component } from "react";
import { Modal, Button } from "react-bootstrap";
import { ModalStyled } from "../../../../theme/customizedStyleComponents";

export default class SubjectCellRenderer extends Component {
	constructor(props) {
		super(props);
		this.state = {
			show: false,
		}
	}

	handleShow = () => {
		if (this.props.data.subject) {
			this.setState({ show: true });
		}
	}

	handleClose = () => {
		this.setState({ show: false });
	}

	render() {
		return (
			<div>
				<div onClick={this.handleShow} style={{ cursor: "pointer" }}>{this.props.data.subject}</div>

				<ModalStyled
					size="lg"
					aria-labelledby="contained-modal-title-vcenter"
					centered
					show={this.state.show}
					onHide={this.handleClose}
					backdrop="static"
				>
					<Modal.Header closeButton>
						<Modal.Title>Subject</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<form>
							<div className="row form-row">
								<div className="col-12">
									<h4>
										{this.props.data.subject}
									</h4>
								</div>
							</div>
						</form>
					</Modal.Body>
					<Modal.Footer>
						<Button variant="secondary" onClick={this.handleClose}>
							Close
						</Button>
					</Modal.Footer>
				</ModalStyled>
			</div>
		)
	}
}